export const philosophy = [
  {
    icon: "ri-search-eye-line",
    title: "先发现",
    desc: "盯住全网正在起势的话题，在它被反复转述、开始变形之前先把原始信息捞出来。",
  },
  {
    icon: "ri-file-list-3-line",
    title: "再梳理",
    desc: "把零散的片段按时间线重新排列，标出哪些已经证实、哪些还在等后续，让脉络清晰。",
  },
  {
    icon: "ri-history-line",
    title: "后复盘",
    desc: "话题降温之后补一篇总结，讲清楚它为什么热、又为什么凉，这才是围观真正的收获。",
  },
];

export const aboutStats = [
  { value: "183+", label: "收录话题" },
  { value: "6 个", label: "常驻栏目" },
  { value: "260万", label: "累计围观" },
  { value: "每日", label: "更新频率" },
];

export const positioning = [
  "不做传闻的搬运工，只做信息的整理者。",
  "不追求最快，但争取讲得最清楚。",
  "不站队、不带节奏，把判断权交还给你。",
];